<template>
  <section v-if="extras">
    <div class="extras container">
      <extra-module :extra="extra" v-for="extra in extras" :key="extra.slug" />
    </div>
    <div class="text-right container"><router-link :to="{name: 'Extras'}" class="button button-underline">All Extras</router-link></div>
  </section>
</template>

<script>
import ExtraModule from '@/components/common/ExtraModule'

export default {
  name: 'latest-extras',
  props: ['extras'],
  components: {
    ExtraModule
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  $sectionColor: $yellow

  .button-underline
    border-color: $sectionColor

  section
    margin-bottom: 52px
    +tablet
      margin-top: 64px
    .extras
      +tablet
        display: flex
        justify-content: space-between
</style>



// WEBPACK FOOTER //
// LatestExtras.vue?3c31fce4